module.exports = __webpack_public_path__ + "media/images/icon-grid-plus-7d1e0a293f93c8a5a9687a907f0b472c.svg";